import { render, staticRenderFns } from "./ProductMovement.vue?vue&type=template&id=e835daf0"
import script from "./ProductMovement.vue?vue&type=script&lang=js"
export * from "./ProductMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports